module.exports = __webpack_public_path__ + "img/null.6bee352a.png";